import heroImg from "@/assets/contact-hero.jpg";
import type { ReactNode } from "react";

interface Props {
  eyebrow: string;
  title: ReactNode;
  description: string;
  children?: ReactNode;
  image?: string;
  gradientClass?: string;
}

export function PageHero({ eyebrow, title, description, children, image = heroImg, gradientClass = "bg-[#1a237e]" }: Props) {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover" />
        <div className={`absolute inset-0 ${gradientClass} opacity-90`} />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.15),transparent_60%)]" />
      </div>
      <div className="relative container-page py-28 md:py-36 text-primary-foreground">
        <span className="inline-flex items-center rounded-full border border-primary-foreground/30 bg-primary-foreground/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] backdrop-blur">
          {eyebrow}
        </span>
        <h1 className="mt-6 max-w-4xl font-display text-5xl md:text-7xl font-bold leading-[1.05]">
          {title}
        </h1>
        <p className="mt-6 max-w-2xl text-lg md:text-xl text-primary-foreground/85">
          {description}
        </p>
        {children && <div className="mt-10 flex flex-wrap gap-4">{children}</div>}
      </div>
    </section>
  );
}
